import * as React from 'react';
import { translate } from 'components/translate-hoc';

import { ITranslationProps } from 'types/translation';
import { IPageSupportBlockStoreProps } from './page-support-block.container';
import { SupportLinkEventTracker } from 'components/support-link-event-tracker';

import { SUPPORT_TEXT_KEYS } from 'constants/app.constants';
import './page-support-block.styles.less';

/**
 * Support links are uses on error and error-like pages (like "Already Registered")
 */
export class PageSupportBlock extends React.Component<IPageSupportBlockStoreProps & ITranslationProps> {
    public render(): JSX.Element {
        const { dangerouslyTranslateWithHTML: translateKey, faqUrl } = this.props;

        const supportKey: string = faqUrl ? SUPPORT_TEXT_KEYS.FAQ : SUPPORT_TEXT_KEYS.NO_FAQ;
        const supportText: string = translateKey(supportKey, { faqUrl });

        return (
            <SupportLinkEventTracker className="sitegen-page-support-block">
                {supportText}
            </SupportLinkEventTracker>
        );
    }
}

export default translate()(PageSupportBlock);
